import React, {FC} from 'react';
import SharedTransactionTable from './common/SharedTransactionTable';

const TransactionTable: FC = () => {
  return <SharedTransactionTable filterStatus='all' />;
};

export default TransactionTable;
